import types from './types';

export const initialState = {
  editBillingModal: {
    isFetching: false,
    values: {
      city: '',
      country: '',
      currency: '',
      name: '',
      postalCode: '',
      street: '',
      vatNumber: '',
    },
    verify: false,
  },
};

const reducers = {
  [types.EDIT_BILLING_FORM_REQUEST]: (state) => ({
    ...state,
    editBillingModal: {
      ...state.editBillingModal,
      isFetching: true,
    },
  }),

  [types.EDIT_BILLING_FORM_SUCCESS]: (state) => ({
    ...state,
    editBillingModal: {
      ...initialState.editBillingModal,
    },
  }),

  [types.EDIT_BILLING_FORM_FAILURE]: (state) => ({
    ...state,
    editBillingModal: {
      ...initialState.editBillingModal,
    },
  }),
};

const reducer = (state = initialState, action = {}) => {
  if (reducers[action.type]) {
    return reducers[action.type](state, action);
  }
  return state;
};

export default reducer;
